export default __webpack_public_path__ + "static/calendar-v2-render@2x-5f93fbcece2641373bd952f1f12331a9.png";